module.exports = __webpack_public_path__ + "img/2.626f5eb1.svg";